import type { MapMouseEvent } from "maplibre-gl";
import type { SyntheticEvent } from "react";

import {
  DATA_E2E_KEY,
  MAP_DATA_CONTROLS_SELECTOR,
  STATION_ROUTE_WAYPOINT_TOOLBAR_E2E,
} from "@ryde/shared";

const WAYPOINT_MAP_UI_SELECTORS = [
  `[${DATA_E2E_KEY}="${STATION_ROUTE_WAYPOINT_TOOLBAR_E2E}"]`,
  `[${DATA_E2E_KEY}="station-route-waypoint-hover-menu"]`,
  `[${DATA_E2E_KEY}="station-route-waypoint-popper-panel"]`,
  MAP_DATA_CONTROLS_SELECTOR,
] as const;

export const stopMapEventPropagation = (event: SyntheticEvent): void => {
  event.stopPropagation();
};

/** Ignore map clicks that land on waypoint UI or other map overlays. */
export const isStationRouteWaypointMapUiClick = (
  event: MapMouseEvent,
): boolean => {
  const target = event.originalEvent?.target;

  if (!(target instanceof HTMLElement)) {
    return false;
  }

  return WAYPOINT_MAP_UI_SELECTORS.some(selector => target.closest(selector));
};
